export class TiposServicio {
    tratamientosServicio: TratamientoServicio[];
    entregaServicio: EntregaServicio[];
    maxContenidos?: number;

    constructor() { }

    static toModel(json: string): TiposServicio {
        const data = JSON.parse(json);
        const toReturn = new TiposServicio();

        toReturn.tratamientosServicio = data.TRATAMIENTOS_SERVICIO.map(tratamiento => TratamientoServicio.toModel(JSON.stringify(tratamiento)));
        toReturn.entregaServicio = data.ENTREGA_SERVICIO.map(tratamiento => EntregaServicio.toModel(JSON.stringify(tratamiento)));
        toReturn.maxContenidos = data.MAX_CONTENIDOS_BY_ROL;
        return toReturn;
    }
}

export class TratamientoServicio {
    id: number;
    tipoEnvio: string;
    tipoServicio: string;
    paramServicio: string;
    autorizacion: string;
  orden: number;
  motivosPeticion: MotivosPeticion[];
  default: boolean;


    constructor() { }

    static toModel(json: string): TratamientoServicio {
        const data = JSON.parse(json);
        const toReturn = new TratamientoServicio();

        toReturn.id = data.ID;
        toReturn.tipoEnvio = data.TIPO_ENVIO;
        toReturn.tipoServicio = data.TIPO_SERVICIO;
        toReturn.paramServicio = data.PARAM_SERVICIO;
        toReturn.autorizacion = data.AUTORIZACION;
        toReturn.orden = data.ORDEN;
        toReturn.motivosPeticion = data.MotivosPeticion.map((motivos: any) => MotivosPeticion.toModel(JSON.stringify(motivos)));
        toReturn.default = data.DEFAULT;
        return toReturn;
    }
}

export class MotivosPeticion {
  id: number;
  motivo: string;
  DespliegueCajaTexto: boolean;
  needAutorization: boolean;

  constructor() { }

  static toModel(json: string): MotivosPeticion {
    const data = JSON.parse(json);
    const toReturn = new MotivosPeticion();

    toReturn.id = data.ID;
    toReturn.motivo = data.MOTIVO;
    toReturn.DespliegueCajaTexto = data.DespliegueCajaTexto;
    toReturn.needAutorization = data.NecesitaAutorizacion;
    return toReturn;
  }
}

export class EntregaServicio {
    id: number;
    parametro: string;
    autorizacion: string;
    default: boolean;

    constructor() { }

    static toModel(json: string): EntregaServicio {
        const data = JSON.parse(json);
        const toReturn = new EntregaServicio();

        toReturn.id = data.ID;
        toReturn.parametro = data.PARAMETRO;
        toReturn.autorizacion = data.AUTORIZACION;
        toReturn.default = data.DEFAULT;
        return toReturn;
    }
}
